import { createTheme } from "@mui/material";
import { getBrandConfig } from "./branding";

/**
 * Theme is dynamically generated based on the current brand.
 *
 * Pretty Chitty colors:
 * #450693 - Deep Purple (background)
 * #8C00FF - Bright Purple (primary)
 * #FF3F7F - Pink (secondary)
 * #FFC400 - Gold/Yellow (accent)
 *
 * Really Chitty colors:
 * #0D4A47 - Deep Teal (background)
 * #6AECE1 - Bright Cyan (primary)
 * #FFB76C - Orange (secondary)
 * #FFF57E - Yellow (accent)
 */

const brandColors = getBrandConfig().colors;

export const theme = createTheme({
  palette: {
    background: {
      default: brandColors.backgroundDark,
      paper: brandColors.backgroundPaper,
    },
    primary: {
      main: brandColors.primary,
      light: brandColors.primaryLight,
      dark: brandColors.primaryDark,
      contrastText: brandColors.textPrimary,
    },
    secondary: {
      main: brandColors.secondary,
      light: brandColors.secondaryLight,
      dark: brandColors.secondaryDark,
      contrastText: brandColors.textPrimary,
    },
    text: {
      primary: brandColors.textPrimary,
      secondary: brandColors.textSecondary,
    },
    info: {
      main: brandColors.accent,
    },
    success: {
      main: "#d8d8d8",
    },
    grey: {
      400: "#ccccb8",
    },
  },
  typography: {
    fontFamily: "'Quicksand', sans-serif",
    fontSize: 16,
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 600,
      textTransform: "none",
    },
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          borderRadius: 8,
        },
        outlined: {
          borderColor: "rgba(255, 255, 255, 0.15)",
          backgroundColor: "rgba(255, 255, 255, 0.06)",
          backdropFilter: "blur(4px)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        },
      },
    },
  },
  cssVariables: true,
});
